import { render, staticRenderFns } from "./maintenasset.vue?vue&type=template&id=5b1408dc"
import script from "./maintenasset.vue?vue&type=script&lang=js"
export * from "./maintenasset.vue?vue&type=script&lang=js"
import style0 from "./maintenasset.vue?vue&type=style&index=0&id=5b1408dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports